export default "__VITE_ASSET__D_LldO9c__"